/**
 * Cliente API del mantenedor de eWeLink (F4).
 *
 * Lo único editable es qué dispositivos puede operar el portal. Las
 * credenciales (correo, clave, región) son variables de entorno del
 * servidor y no se editan por API (convención #17), y el modo
 * (`simulacion` / `real`) tampoco: se cambia en Render, porque un clic no
 * debe poder pasar de "el sistema no escribe" a "el sistema abre portones".
 */
import { apiFetch } from './client';

export type ModoEwelink = 'simulacion' | 'real' | 'falso';

export interface DispositivoEwelinkRead {
  id: string;
  deviceid: string;
  nombre: string;
  canal: string;
  es_virtual: boolean;
  administrado: boolean;
  limite_usuarios: number;
  /** Compartidos que eWeLink reporta ahora. null = no se pudo consultar. */
  usados: number | null;
}

export interface EstadoEwelinkRead {
  conexion_ok: boolean;
  mensaje: string;
  region: string;
  modo: ModoEwelink;
  cuenta: string | null;
  consultado_at: string | null;
}

export interface InventarioEwelinkRead {
  estado: EstadoEwelinkRead;
  dispositivos: DispositivoEwelinkRead[];
}

export interface SincronizacionRead {
  creados: number;
  actualizados: number;
  sin_cambios: number;
  no_reconocidos: string[];
  inventario: InventarioEwelinkRead;
}

export function getInventarioEwelink(): Promise<InventarioEwelinkRead> {
  return apiFetch<InventarioEwelinkRead>('/sa/ewelink/inventario');
}

/** "Probar conexión": trae la lista desde eWeLink. No pisa `administrado`. */
export function sincronizarEwelink(): Promise<SincronizacionRead> {
  return apiFetch<SincronizacionRead>('/sa/ewelink/sincronizar', {
    method: 'POST',
  });
}

export function actualizarDispositivoEwelink(
  deviceid: string,
  administrado: boolean,
): Promise<DispositivoEwelinkRead> {
  return apiFetch<DispositivoEwelinkRead>(
    `/sa/ewelink/dispositivos/${encodeURIComponent(deviceid)}`,
    { method: 'PATCH', body: JSON.stringify({ administrado }) },
  );
}
